if (!customElements.get('m-shipping-info-modal')) {
  customElements.define(
    'm-shipping-info-modal',
    class MShippingInfoModal extends HTMLElement {
      constructor() {
        super();
        this.modal = null;
      }

      connectedCallback() {
        this.template = this.querySelector('[data-shipping-info-content]');
        this.trigger = this.querySelector('[data-open-shipping-info]');
        if (!this.template || !this.trigger) return;

        this.trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.openModal();
        });
      }

      openModal() {
        if (!window.MinimogTheme || !window.MinimogTheme.Modal) return;

        if (!this.modal) {
          this.modal = new MinimogTheme.Modal();
        }

        const modalRoot = this.template.content.querySelector('.vy-shipping-modal');
        const colorScheme = modalRoot?.dataset.colorScheme || '';
        const wrapper = document.createElement('div');
        wrapper.appendChild(this.template.content.cloneNode(true));
        this.modal.appendChild(wrapper);
        this.modal.setWidth('480px');
        this.modal.setSizes(`vy-shipping-modal-wrap m-gradient ${colorScheme}`.trim());
        this.modal.open();
      }
    }
  );
}
